import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://metodoeva.com/cart/55668519665737:1" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-coral hover:bg-coral-hover text-white font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-colors duration-300 text-center text-lg md:text-xl ${className}`} data-id="element-14">
      {children}
    </motion.a>;
}